import React, {ChangeEvent, FormEvent, ReactElement} from "react";
import {Dialog} from "@headlessui/react";
import {FormattedMessage} from "react-intl";
import {menuManagementActions, menuManagementSelectors} from "./menuManagementSlice";
import {useAppDispatch, useAppSelector} from "lib/redux/hooks";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {ErrorMessage} from "../../../components/UIComponents/ErrorMessage";
import {Spinner} from "../../../components/UIComponents/Spinner";
import {authSelectors} from "../../auth/authSlice";
import {PrimaryButton} from "../../../components/UIComponents/PrimaryButton";
import {SecondaryButton} from "../../../components/UIComponents/SecondaryButton";

export interface RenameModalProps {

}

export function RenameModal(props: RenameModalProps): ReactElement {
    const dispatch = useAppDispatch();
    const menuId = useAppSelector(menuManagementSelectors.renameModalMenuId);
    const menuName = useAppSelector(menuManagementSelectors.renameModalMenuName);
    const inputValue = useAppSelector(menuManagementSelectors.renameModalInputValue);
    const renameModalOpen = useAppSelector(menuManagementSelectors.renameModalOpen);
    const pending = useAppSelector(menuManagementSelectors.renamePending);
    const error = useAppSelector(menuManagementSelectors.renameError);
    const userId = useAppSelector(authSelectors.customer);

    const closeRenameModal = () => dispatch(menuManagementActions.closeRenameModal());
    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => dispatch(menuManagementActions.setRenameInputValue(e.target.value));
    const submitRename = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (userId == null) {
            dispatch(menuManagementActions.setRenameError("keine userId vorhanden"));
            return;
        }

        if (menuId == null) {
            dispatch(menuManagementActions.setRenameError("keine menuid vorhanden"));
            return;
        }

        return dispatch(menuManagementActions.renameMenu({
            userId: userId,
            fileId: menuId,
            name: inputValue
        }));
    };
    return (
        <Dialog
            open={renameModalOpen}
            onClose={closeRenameModal}
            className="fixed z-modal inset-0 overflow-y-auto"
        >
            <div className="flex items-center justify-center min-h-screen">
                <Dialog.Overlay className="fixed inset-0 bg-text opacity-60"/>

                <div className="relative flex flex-col w-1/3 max-w-sm mx-auto
                                py-6 px-5 bg-white rounded-lg">
                    <div className="flex-none flex items-center">
                        <Dialog.Title className="flex-auto font-barlow text-lg font-semibold">
                            <FormattedMessage id="management.rename.modal.title"/>
                        </Dialog.Title>
                        <button className="flex-none"
                                onClick={closeRenameModal}>
                            <CloseIcon className="inline-block w-5 h-5" />
                        </button>
                    </div>

                    <form className="flex-auto flex flex-col"
                          onSubmit={submitRename}>
                        <p className="mt-5 mb-10">
                            <input
                                autoFocus
                                type="text"
                                placeholder={menuName ?? ""}
                                onChange={onInputChange}
                                value={inputValue}
                                disabled={pending}
                                className="w-full border border-text py-5 px-6 mb-2
                                           font-barlow text-lg font-semibold text-text"
                            />
                            {error && (
                                <ErrorMessage><FormattedMessage id="management.rename.modal.error" values={{message: error}} /></ErrorMessage>
                            )}
                        </p>

                        <div className="flex-none flex gap-2 justify-end items-center">
                            {pending && (
                                <Spinner className="flex-none w-8 h-8 inline-block" />
                            )}

                            <SecondaryButton onClick={closeRenameModal}>
                                <FormattedMessage id="management.rename.modal.button.cancel"/>
                            </SecondaryButton>

                            <PrimaryButton disabled={pending}>
                                <FormattedMessage id="management.rename.modal.button.submit"/>
                            </PrimaryButton>
                        </div>
                    </form>
                </div>
            </div>
        </Dialog>
    );
}